<div class="title" mat-dialog-title>
	{{data.title | translate}}
</div>

<div class="msg" mat-dialog-content>
	@if(data.msg){
		{{data.msg | translate}}
	}

	@if(data.subMessage){
		@if(data.msg){
			<br><br> <!-- Add one line as space -->
		}
		<div [innerHtml]="data.subMessage">
		</div>
	}
</div>


<mat-dialog-actions class="buttons">
	<button mat-raised-button [mat-dialog-close]="'no'">
		{{data.no | translate}}
	</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="'yes'">
		{{data.yes | translate}}
	</button>
</mat-dialog-actions>
